"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ShadeWithName = require("./ShadeWithName");
Object.keys(_ShadeWithName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ShadeWithName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ShadeWithName[key];
    }
  });
});
